/* ============================================
   LOFLLY Liquid Glass Navigation v2.2
   ============================================ */

(function () {
  'use strict';

  // —— 配置 ——
  var SELECTORS = {
    header:        '.header',
    headerBg:      '.header__container--with-bg',
    nav:           '.header__nav',
    menuItem:      '.header__item',
    dropdown:      '.header__dropdown'
  };

  var CLASSES = {
    hovered:       'loflly-nav--hovered',
    dropdownOpen:  'loflly-nav--dropdown-open',
    pillHost:      'loflly-nav__pill-host',
    pill:          'loflly-nav-pill',
    pillVisible:   'loflly-nav-pill--visible'
  };

  var DESKTOP_MQ = '(min-width: 768px)';
  var DEBUG = false;

  function warn(msg, err) {
    if (DEBUG && typeof console !== 'undefined') {
      console.warn('[LOFLLY Nav] ' + msg, err || '');
    }
  }

  // —— 全局状态：用于 section 重载时清理 ——
  var teardowns = [];

  function teardownAll() {
    for (var i = 0; i < teardowns.length; i++) {
      try { teardowns[i](); } catch (e) { /* swallow */ }
    }
    teardowns = [];
  }

  // ============================================
  // 模块 1：桌面端 hover 触发奶白毛玻璃
  // ============================================
  function initDesktopNavHover() {
    var header = document.querySelector(SELECTORS.headerBg);
    if (!header) return;

    function add()    { header.classList.add(CLASSES.hovered); }
    function remove() { header.classList.remove(CLASSES.hovered); }
    function onFocusOut(e) {
      if (!header.contains(e.relatedTarget)) remove();
    }

    header.addEventListener('mouseenter', add);
    header.addEventListener('mouseleave', remove);
    header.addEventListener('focusin',    add);
    header.addEventListener('focusout',   onFocusOut);

    teardowns.push(function () {
      header.removeEventListener('mouseenter', add);
      header.removeEventListener('mouseleave', remove);
      header.removeEventListener('focusin',    add);
      header.removeEventListener('focusout',   onFocusOut);
      header.classList.remove(CLASSES.hovered);
    });
  }

  // ============================================
  // 模块 2：桌面端滑动胶囊 pill
  // ============================================
  function initDesktopPill() {
    var nav = document.querySelector(SELECTORS.nav);
    if (!nav) return;

    // 用 class 而非 inline style，避免 Aurora 更新冲突
    nav.classList.add(CLASSES.pillHost);

    // 复用已有 pill（section 重载场景）
    var pill = nav.querySelector('.' + CLASSES.pill);
    if (!pill) {
      pill = document.createElement('div');
      pill.className = CLASSES.pill;
      pill.setAttribute('aria-hidden', 'true');
      nav.appendChild(pill);
    }

    var rafId = null;
    var lastTarget = null;

    function moveTo(target) {
      if (target === lastTarget) return;
      lastTarget = target;

      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        var navRect = nav.getBoundingClientRect();
        var rect    = target.getBoundingClientRect();
        var x = rect.left - navRect.left + 4;
        var y = rect.top  - navRect.top  + 8;
        var w = rect.width  - 8;
        var h = rect.height - 16;

        pill.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
        pill.style.width  = w + 'px';
        pill.style.height = h + 'px';
        pill.classList.add(CLASSES.pillVisible);
      });
    }

    function hide() {
      lastTarget = null;
      if (rafId) cancelAnimationFrame(rafId);
      pill.classList.remove(CLASSES.pillVisible);
    }

    function onMouseOver(e) {
      var item = e.target.closest(SELECTORS.menuItem);
      if (item && nav.contains(item)) moveTo(item);
    }

    function onFocusIn(e) {
      var item = e.target.closest(SELECTORS.menuItem);
      if (item) moveTo(item);
    }

    function onFocusOut(e) {
      if (!nav.contains(e.relatedTarget)) hide();
    }

    nav.addEventListener('mouseover',  onMouseOver);
    nav.addEventListener('mouseleave', hide);
    nav.addEventListener('focusin',    onFocusIn);
    nav.addEventListener('focusout',   onFocusOut);

    teardowns.push(function () {
      nav.removeEventListener('mouseover',  onMouseOver);
      nav.removeEventListener('mouseleave', hide);
      nav.removeEventListener('focusin',    onFocusIn);
      nav.removeEventListener('focusout',   onFocusOut);
      if (rafId) cancelAnimationFrame(rafId);
      if (pill && pill.parentNode) pill.parentNode.removeChild(pill);
      nav.classList.remove(CLASSES.pillHost);
    });
  }

  // ============================================
  // 模块 3：子菜单状态 class (老浏览器 :has fallback)
  // ============================================
  function initDropdownStateClass() {
    // 现代浏览器支持 :has() → 纯 CSS 已覆盖，不跑 JS
    if (window.CSS && CSS.supports && CSS.supports('selector(:has(*))')) return;

    var header = document.querySelector(SELECTORS.header);
    if (!header) return;

    function update() {
      var open = header.querySelector(SELECTORS.dropdown + '[aria-hidden="false"]');
      header.classList.toggle(CLASSES.dropdownOpen, !!open);
    }

    var observer = new MutationObserver(update);
    var dropdowns = header.querySelectorAll(SELECTORS.dropdown);
    for (var i = 0; i < dropdowns.length; i++) {
      observer.observe(dropdowns[i], {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    teardowns.push(function () {
      observer.disconnect();
      header.classList.remove(CLASSES.dropdownOpen);
    });
  }

  // ============================================
  // 入口
  // ============================================
  function init() {
    try {
      teardownAll();

      var isDesktop = window.matchMedia(DESKTOP_MQ).matches;
      if (isDesktop) {
        initDesktopNavHover();
        initDesktopPill();
      }

      initDropdownStateClass();
      bindBreakpointReinit();

    } catch (err) {
      warn('init failed:', err);
    }
  }

  // —— 视口断点切换：重建桌面专属逻辑 ——
  var mqList = null;
  function bindBreakpointReinit() {
    if (mqList) return;
    mqList = window.matchMedia(DESKTOP_MQ);

    var handler = function () { init(); };

    if (mqList.addEventListener) {
      mqList.addEventListener('change', handler);
    } else if (mqList.addListener) {
      mqList.addListener(handler); // Safari < 14
    }
  }

  // —— 启动 ——
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // —— Shopify customizer / section 重载支持 ——
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && (
        e.target.querySelector(SELECTORS.headerBg) ||
        e.target.classList.contains('shopify-section-header'))) {
      init();
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && (
        e.target.querySelector(SELECTORS.headerBg) ||
        e.target.classList.contains('shopify-section-header'))) {
      teardownAll();
    }
  });

})();
